(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Initialize the gallery with GSAP ScrollTrigger
  function initGallery() {
    const galleryWrapper = document.querySelector('.gallery-wrapper');
    const gallerySlides = document.querySelectorAll('.gallery-slide');
    const gallerySlidesContainer = document.querySelector('.gallery-slides');

    // Calculate total width of the gallery
    function calculateTotalWidth() {
      let totalWidth = 0;
      gallerySlides.forEach(slide => {
        totalWidth += slide.offsetWidth + 1; // Include 1px spacer
      });
      return totalWidth;
    }

    // Set the width of the slides container
    function setGalleryWidth() {
      const totalWidth = calculateTotalWidth();
      gallerySlidesContainer.style.width = `${totalWidth}px`;
    }

    // Initialize GSAP ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    // Create horizontal scroll animation
    function createScrollAnimation() {
      const totalWidth = calculateTotalWidth();
      gsap.to(gallerySlidesContainer, {
        x: () => -(totalWidth - window.innerWidth), // Scroll distance
        ease: 'none',
        scrollTrigger: {
          trigger: galleryWrapper,
          start: 'top top', // Start when the top of the gallery hits the top of the viewport
          end: () => `+=${totalWidth}`, // End after scrolling the total width
          pin: true, // Pin the gallery while scrolling
          scrub: 0.5, // Adjust scrub value for faster scrolling
          invalidateOnRefresh: true, // Recalculate on resize
          anticipatePin: 1, // Improve performance
        },
      });
    }

    // Set initial gallery width and create scroll animation
    setGalleryWidth();
    createScrollAnimation();

    // Refresh ScrollTrigger after all media is loaded
    window.addEventListener('load', () => {
      setGalleryWidth();
      ScrollTrigger.refresh();
    });

    // Recalculate on window resize
    window.addEventListener('resize', () => {
      setGalleryWidth();
      ScrollTrigger.refresh();
    });

    // Use ResizeObserver to detect changes in the gallery's dimensions
    const resizeObserver = new ResizeObserver(() => {
      setGalleryWidth();
      ScrollTrigger.refresh();
    });

    resizeObserver.observe(gallerySlidesContainer);
  }

  // Initialize the gallery
  initGallery();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headerWrapper = document.querySelector('.section-header'); // Outer header
    this.header = document.querySelector('.header'); // Inner header
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.headerWrapper.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    // Watch for megamenu open/close events
    this.setupMegamenuWatcher();

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.headerWrapper);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling down
      this.headerWrapper.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling up
      this.headerWrapper.classList.add('scrolled-past-header', 'header--white'); // Add both classes
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      // At the top of the page
      if (!this.isAnyMegamenuOpen()) {
        this.headerWrapper.classList.remove('scrolled-past-header', 'header--white'); // Remove both classes
      }
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.headerWrapper.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.headerWrapper.classList.add('shopify-section-header-sticky', 'animate');
    this.headerWrapper.classList.remove('shopify-section-header-hidden');
  }

  reset() {
  if (this.headerIsAlwaysSticky) return;

  // Remove white class from outer header at the top of the page (if no megamenu is open)
  if (!this.isAnyMegamenuOpen()) {
    this.headerWrapper.classList.remove('header--white');
  } else {
    // Ensure the header is white if any megamenu is open
    this.headerWrapper.classList.add('header--white');
  }

  this.headerWrapper.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

  isAnyMegamenuOpen() {
    const megamenus = this.header.querySelectorAll('.mega-menu'); // Get all megamenus
    return Array.from(megamenus).some(megamenu => megamenu.hasAttribute('open')); // Check if any megamenu is open
  }

  setupMegamenuWatcher() {
  const megamenus = this.header.querySelectorAll('.mega-menu'); // Get all megamenus
  megamenus.forEach(megamenu => {
    megamenu.addEventListener('toggle', () => {
      if (this.isAnyMegamenuOpen()) {
        // If any megamenu is open, ensure the header is white
        this.headerWrapper.classList.add('header--white');
      } else if (this.currentScrollTop <= this.headerBounds.top) {
        // If no megamenu is open and we are at the top of the page, remove the white class
        this.headerWrapper.classList.remove('header--white');
      }
    });
  });
}

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headerWrapper = document.querySelector('.section-header');
    this.header = document.querySelector('.header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.headerWrapper.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.headerWrapper);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling down
      this.headerWrapper.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scrolling up
      this.headerWrapper.classList.add('scrolled-past-header', 'header--white');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      // At the top of the page
      if (!this.isAnyMegamenuOpen()) {
        this.headerWrapper.classList.remove('scrolled-past-header', 'header--white');
      }
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.headerWrapper.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.headerWrapper.classList.add('shopify-section-header-sticky', 'animate');
    this.headerWrapper.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;

    // Remove white class from outer header at the top of the page (if no megamenu is open)
    if (!this.isAnyMegamenuOpen()) {
      this.headerWrapper.classList.remove('header--white');
    } else {
      // Ensure the header is white if any megamenu is open
      this.headerWrapper.classList.add('header--white');
    }

    this.headerWrapper.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  isAnyMegamenuOpen() {
    // Check if HeaderController exists and has any open menus
    if (window.headerController && window.headerController.isAnyMenuOpen) {
      return window.headerController.isAnyMenuOpen();
    }
    return false;
  }

  closeMenuDisclosure() {
    // Close menus through HeaderController if available
    if (window.headerController && window.headerController.closeAllMenus) {
      window.headerController.closeAllMenus();
    }
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
